import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { AlertCircle } from 'react-feather';
import { connect } from 'react-redux';
import { saveDraft } from 'actions/pathBuilder/index';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import Select from 'components/shared/select';
import { routes } from 'constants/config';
import { hasFeature } from 'selectors/index';
import { Button, ButtonGroup, Icon } from 'ui';
import { useColors } from 'ui/hooks';
import request from 'utils/request_ajax';
import SelectWorkspace from './SelectWorkspace';

const preventLineBreaks = e => {
  if (e.key === 'Enter') e.preventDefault();
};

const CertificationPathCreationModal = ({
  workspaces,
  features,
  closeModal,
  saveCertificationDraft,
}) => {
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [contentType, setContentType] = useState('path');
  const [workspaceId, setWorkspaceId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const canAssignWorkspace = features.workspaces && workspaces.length > 1;
  const { colorPrimary, colorOnPrimary } = useColors();

  const DEFAULT_CERTIFICATION = {
    backgroundColor: colorPrimary,
    foregroundColor: colorOnPrimary,
    iconName: 'thumbs_up',
    id: null,
    image: null,
    public: true,
  };

  const createCertification = () => {
    const data = {
      certification: DEFAULT_CERTIFICATION,
      title,
      description,
      workspaceId,
    };
    request
      .postJSON(routes.PATHS, data)
      .then(createData => {
        saveCertificationDraft();
        closeModal();
        window.location.assign(createData.urls.overview);
        return createData;
      })
      .catch(e => console.error(e));
  };

  const handleContentTypeChange = value => {
    setContentType({ contentType: value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    setIsLoading(true);
    createCertification();
  };

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        <div className="ModalTakeover-container LessonCreationModal">
          <div className="LessonCreationModal-body">
            <form onSubmit={handleSubmit}>
              <div className="LessonCreationModal-title">
                {t('certifications.create_modal.title')}
              </div>
              <div className="LessonCreationModal-subtitle">
                {t('certifications.create_modal.description')}
              </div>
              <label htmlFor="title" className="LessonCreationModal-inputTitle">
                {t('common.title')}
              </label>
              <input
                id="title"
                name="title"
                className="NewInput NewInput--white NewInput--fw ModalTakeover-nameInput"
                placeholder={t('common.enter_title')}
                type="text"
                onChange={e => setTitle(e.target.value)}
                value={title}
                maxLength="255"
              />
              <label
                htmlFor="description"
                className="LessonCreationModal-inputTitle"
              >
                {t('common.description')}
              </label>
              <textarea
                id="description"
                name="description"
                className="NewInput NewInput--white NewInput--fw"
                placeholder={t('common.enter_description')}
                rows="3"
                onChange={e => setDescription(e.target.value)}
                onKeyDown={preventLineBreaks}
                value={description}
              />
              <div>
                <label
                  htmlFor="contentType"
                  className="ScenarioCreationModal-inputTitle d-f fd-r ai-c"
                >
                  <span>{t('certifications.create_modal.type')}</span>
                  <span
                    className="ml-8 h-c-night"
                    data-toggle="tooltip"
                    title={t('certifications.create_modal.type_tooltip')}
                    data-placement="top"
                    role="button"
                    tabIndex="0"
                  >
                    <AlertCircle size={17} />
                  </span>
                </label>
                <Select
                  name="contentType"
                  id="contentType"
                  fullWidth
                  onChange={handleContentTypeChange}
                >
                  <option value={contentType}>
                    {t('certifications.create_modal.types.path')}
                  </option>
                </Select>
              </div>
              {canAssignWorkspace && (
                <div>
                  <SelectWorkspace
                    workspaces={workspaces}
                    onChange={e => setWorkspaceId(e.target.value)}
                  />
                </div>
              )}
              <ButtonGroup alignEnd className="mt-32">
                <Button
                  customColor
                  type="submit"
                  loading={isLoading}
                  disabled={!title}
                >
                  {t('certifications.create_modal.create_button')}
                </Button>
              </ButtonGroup>
            </form>

            <button
              type="button"
              aria-label={t('common.close')}
              className="u-resetBtn ModalTakeover-closeButton"
              onClick={closeModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

CertificationPathCreationModal.propTypes = {
  closeModal: PropTypes.func,
};

const mapStateToProps = state => ({
  features: {
    workspaces: hasFeature(state, 'workspaces'),
  },
  workspaces: state.data.meta.workspaceOptions,
});

const mapDispatchToProps = {
  saveCertificationDraft: saveDraft,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CertificationPathCreationModal);
